import { error, success } from '@fever/ui';
import { POINT_RECORD_ACTION } from '../config';

export const getPointsColor = number => {
    return number < 0 ? error : success;
};

/**
 * @method getPointsColorByAction
 * @name 透過點數紀錄操作類型取得點數樣式顏色
 * @param {number} action 點數紀錄操作類型
 * @return {string}
 */
export const getPointsColorByAction = action => {
    return action === POINT_RECORD_ACTION.DEDUCT ? error : success;
};
